<app-input-text
  class="no-icon"
  [formData]="getCronInput()">
</app-input-text>

@if (formGroup.get('cron')?.touched && formGroup.get('cron')?.hasError('invalidCron')) {
  <small class="error-text">
    {{ 'common.alarm-rule.trigger.cron-job.invalid' | translateSafe }}
  </small>
}

<span class="info">
  {{ 'common.alarm-rule.trigger.cron-job.info' | translateSafe }}
</span>